import React from "react";

const convertToJalali = (x) => {
  const A = x.slice(0, 10);
  const B = x.slice(11, 19);
  const C = new Date(A);
  const D = new Intl.DateTimeFormat("fa-IR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(C);
  return `${D} (${B})`;
};

const SortChartLabels = (labels, dataType, rangeType) => {
  if ((labels, dataType, rangeType)) {
    const reversedLabels = [...labels].reverse();
    const labelDates = reversedLabels.map((date) => convertToJalali(date));
    const persianLabels = labelDates;

    let indexOfShownLabels = 0;

    if (dataType === "online" && rangeType === "daily") {
      indexOfShownLabels = 60;
    } else if (dataType === "online" && rangeType === "custom3DaysLimit") {
      indexOfShownLabels = 180;
    } else if (dataType === "hourly" && rangeType === "daily") {
      indexOfShownLabels = 1;
    } else if (dataType === "hourly" && rangeType === "weekly") {
      indexOfShownLabels = 24;
    } else if (dataType === "hourly" && rangeType === "custom30DaysLimit") {
      indexOfShownLabels = 24;
    } else if (dataType === "hourly" && rangeType === "monthly") {
      indexOfShownLabels = 72;
    } else if (dataType === "daily" && rangeType !== "yearly") {
      indexOfShownLabels = 3;
    } else if (dataType === "daily" && rangeType === "yearly") {
      indexOfShownLabels = 7;
    }

    return { persianLabels, indexOfShownLabels };
  }
};

export { SortChartLabels };
